// E8 — экран после logout (post_logout_redirect_uri).
// Keycloak возвращает пользователя сюда после signoutRedirect().
import { AuthScreen, Button, Card } from '@dss/design-system'
import { Check } from 'lucide-react'
import { Link } from '../../lib/router'
import { useDistributorBrand } from '../../lib/distributor-brand'

export function LogoutScreen() {
  const { current: brand } = useDistributorBrand()

  return (
    <AuthScreen brand={brand ?? undefined}>
      <Card padding="lg">
        <div
          aria-hidden="true"
          style={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: 'var(--color-success-bg)',
            color: 'var(--color-success-fg)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <Check size={22} />
        </div>
        <h1
          style={{
            margin: '0 0 8px',
            fontSize: 24,
            fontWeight: 600,
            letterSpacing: '-0.01em',
          }}
        >
          Вы вышли
        </h1>
        <p
          style={{
            margin: '0 0 20px',
            fontSize: 14,
            color: 'var(--color-text-secondary)',
            lineHeight: 1.5,
          }}
        >
          Спасибо за работу. До скорой встречи.
        </p>
        <Link to={`/login${window.location.search}`} style={{ textDecoration: 'none' }}>
          <Button variant="primary" fullWidth>
            Войти заново
          </Button>
        </Link>
      </Card>
    </AuthScreen>
  )
}
